import { useState } from 'react';
import { getRestaurantKey, upsertRestaurantSpecial } from '../utils/restaurantSpecials';

const RestaurantSpecialEditor = ({ item, auth, onSaved, compact = false }) => {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({
    special: item.special || '',
    specialinfo: item.specialinfo || '',
    price: item.price || '',
  });
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);

  const handleChange = (field, value) => {
    setValues((prev) => ({ ...prev, [field]: value }));
    setStatus('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setSaving(true);
    setStatus('');

    try {
      const response = await upsertRestaurantSpecial({
        restaurantKey: getRestaurantKey(item),
        restaurantName: item.name,
        address: item.address || '',
        ...values,
      }, auth.accessToken);

      onSaved?.(response.data);
      setStatus('Published — special is live now.');
      setOpen(false);
    } catch (err) {
      setStatus(err?.response?.data?.message || 'Could not publish special. Try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`map-special-editor${compact ? ' map-special-editor--compact' : ''}`}>
      <button
        type="button"
        className="map-special-editor-toggle"
        onClick={(event) => {
          event.stopPropagation();
          setOpen((prev) => !prev);
        }}
      >
        {open ? 'Hide editor' : 'Edit special (editor)'}
      </button>

      {open && (
        <form className="map-special-editor-fields" onSubmit={handleSubmit}>
          <label className="map-special-editor-field">
            <span>Today&apos;s special</span>
            <input
              type="text"
              value={values.special}
              onChange={(event) => handleChange('special', event.target.value)}
              onClick={(event) => event.stopPropagation()}
              maxLength={120}
              required
            />
          </label>
          <label className="map-special-editor-field">
            <span>Details</span>
            <textarea
              value={values.specialinfo}
              onChange={(event) => handleChange('specialinfo', event.target.value)}
              onClick={(event) => event.stopPropagation()}
              maxLength={400}
              rows={3}
            />
          </label>
          <label className="map-special-editor-field">
            <span>Price range</span>
            <input
              type="text"
              value={values.price}
              onChange={(event) => handleChange('price', event.target.value)}
              onClick={(event) => event.stopPropagation()}
              maxLength={40}
              placeholder="$12–16"
            />
          </label>
          <button
            type="submit"
            className="map-special-editor-submit"
            disabled={saving}
            onClick={(event) => event.stopPropagation()}
          >
            {saving ? 'Publishing…' : 'Publish special'}
          </button>
        </form>
      )}

      {status && (
        <p className={`map-special-editor-status${status.startsWith('Published') ? ' success' : ' error'}`}>
          {status}
        </p>
      )}
    </div>
  );
};

export default RestaurantSpecialEditor;